import { render } from "./DetailCompany.vue?vue&type=template&id=c925c156&scoped=true"
import script from "./DetailCompany.vue?vue&type=script&lang=js"
export * from "./DetailCompany.vue?vue&type=script&lang=js"

import "./DetailCompany.vue?vue&type=style&index=0&id=c925c156&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c925c156"]])

export default __exports__